<template>
  <div>
    <v-toolbar dark color="primary">
      <v-toolbar-title>
        <div class="d-flex flex-column">
          <strong>وبکارت</strong>
          <small class="text-muted text-small"
            >گزارش ورود و خروج در بازه پرسنل</small
          >
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div id="viewer" dir="ltr"></div>
    <dialog-waiting ref="DialogWaiting"/>
  </div>
</template>

<script>
import reportFile from "../../assets/reports/personelIO.mrt";
import reportTexts from "../../assets/js/reports";
import EosUtils from "../../utils/EosUtils";
import ResultType from "../../model/ResultType";
import DialogWaiting from '../../components/widget/DialogWaiting.vue';

export default {
  components: { DialogWaiting },
  data() {
    return {
      visible: false,
      dataLoaded: false,
      infoDataSet: null,
      personelIOInfo: null,
    };
  },
  mounted() {
    this.loadPage();
  },
  watch: {
    dataLoaded(newVal) {
      if (newVal) {
        this.showReport();
      }
    },
  },
  methods: {
    loadPage() {
      this.$refs.DialogWaiting.show()

      var args = this.$route.query;
      var perno = this.$store.state.auth.auth.username;
      var beginDate = args.BD;
      var endDate = args.ED;
      var dedicatedPerno = args.dp;

      this.ValidateQueryInputs(perno, beginDate, endDate, dedicatedPerno);
      this.getData(perno, beginDate, endDate, dedicatedPerno);
    },
    ValidateQueryInputs(perno, beginDate, endDate, dedicatedPerno) {
      if (!perno) {
        this.transferPage();
      }
      if (!dedicatedPerno) {
        this.transferPage();
      }
      if (!beginDate) {
        this.transferPage();
      }
      if (!endDate) {
        this.transferPage();
      }
    },
    transferPage() {
      //todo : error wrong page
    },
    async getData(perno, beginDate, endDate, dedicatedPerno) {
      var moment = require("jalali-moment");

      var infoDataSet = {};
      if (EosUtils.isWebKartAdmin()) {
        infoDataSet.perno = "-";
        infoDataSet.personName = "مدير وب کارت";
      } else {
        infoDataSet.perno = perno;
        infoDataSet.personName =
          this.$store.state.personel.personelDetail.PersonName;
      }

      infoDataSet.beginDate = beginDate;
      infoDataSet.endDate = endDate;
      infoDataSet.timeNow = moment().locale("fa").format("YYYY/MM/DD HH:mm");
      infoDataSet.companyName = "";
      var GetCustomerNameResponse = await this.$store.dispatch(
        "lock/GetCustomerName"
      );
      if (GetCustomerNameResponse.type == ResultType.success) {
        infoDataSet.companyName = GetCustomerNameResponse.data;
      }

      if (dedicatedPerno == perno) {
        infoDataSet.dedicatePersonName = infoDataSet.personName;
        infoDataSet.dedicatePerson = infoDataSet.perno;
      } else {
        infoDataSet.dedicatePersonName = "";
        infoDataSet.dedicatePerson = dedicatedPerno;
        var EosPersonelDetailResponse = await this.$store.dispatch(
          "EosPersonelDetail",
          { perno: dedicatedPerno }
        );
        if (EosPersonelDetailResponse.type === ResultType.success) {
          var personelDetails = EosPersonelDetailResponse.data;
          infoDataSet.dedicatePersonName = personelDetails.PersonName;
        }
      }

      this.infoDataSet = infoDataSet;

      const params = new URLSearchParams();
      params.append("beginDate", beginDate);
      params.append("endDate", endDate);
      params.append("perno", dedicatedPerno);

      this.$store
        .dispatch("GetPersonIoInfo", {
          params,
        })
        .then((result) => {
          if (result.type === "success") {
            this.personelIOInfo = result.data;
            this.dataLoaded = true;
          }
        });
    },
    showReport() {
      window.Stimulsoft.Base.StiLicense.key = reportTexts.getStimulKey();
      let options = new window.Stimulsoft.Viewer.StiViewerOptions();
      /*options.appearance.fullScreenMode = true;
      options.toolbar.displayMode =
        window.Stimulsoft.Viewer.StiToolbarDisplayMode.Separated;*/
        options.appearance.ScrollbarsMode = true
      var viewer = new window.Stimulsoft.Viewer.StiViewer(
        options,
        "StiViewer",
        false
      );

      let report = window.Stimulsoft.Report.StiReport.createNewReport();
      report.load(reportFile);

      report.dictionary.variables.getByName("FromDate").valueObject =
        this.infoDataSet.beginDate;
      report.dictionary.variables.getByName("ToDate").valueObject =
        this.infoDataSet.endDate;
      report.dictionary.variables.getByName("ReportDate").valueObject =
        this.infoDataSet.timeNow;
      report.dictionary.variables.getByName("CompanyName").valueObject =
        this.infoDataSet.customerName;
      report.dictionary.variables.getByName("dedicatePerson").valueObject =
        this.infoDataSet.dedicatePerson;
      report.dictionary.variables.getByName("dedicatePersonName").valueObject =
        this.infoDataSet.dedicatePersonName;
      report.dictionary.variables.getByName("Perno").valueObject =
        this.infoDataSet.perno;
      report.dictionary.variables.getByName("PersonName").valueObject =
        this.infoDataSet.personName;

      report.regData("d1", "d1", this.personelIOInfo);

      viewer.report = report;
      viewer.renderHtml("viewer");

      this.$refs.DialogWaiting.hide()
    },
  },
};
</script>

<style>
</style>